import { useMemo, useRef } from "react";
import { listGraduateProfiles } from "app/api/adminApis";
import { DATA_GRID_ACTIONS } from "app/components/dataGrid/DataColumn";
import ROUTES from "app/constants/navigation";
import { IGraduateListItem } from "app/models/graduate";
import { appStateSelectors, useAppState } from "app/state/AppState";
import { useNavigate } from "react-router-dom";
import usePagination from "./Pagination";
import { AccountNotificationPopupRef } from "app/components/accountNotification/AccountNotificationPopup";
import * as AppUtils from "app/utils/common";

const useGraduateListing = () => {
  const navigate = useNavigate();

  const subscriptionModalRef = useRef<AccountNotificationPopupRef>(null);

  const _pagination = usePagination<IGraduateListItem>({
    listFn: listGraduateProfiles,
  });

  const grades = useAppState(appStateSelectors.gradeBands);
  const roles = useAppState(appStateSelectors.roles);
  const preferences = useAppState(appStateSelectors.preferences)?.filter(
    pref => pref.category === "Contact"
  );

  const onNewGraduateClick = () => navigate(ROUTES.GRADUATE_PROFILE_EDITOR);

  const classYears = useMemo(() => {
    let years = [];
    for (let i = 1960; i <= 2023; i++) {
      years.push({ id: i, label: i });
    }

    return years;
  }, []);

  // TODO: need to fix the action
  const onToggleActive = (graduate: IGraduateListItem) => async (checked: boolean) => {
    try {
      const formData = new FormData();
      AppUtils.buildFormData(formData, { is_enabled: checked }, null);
      formData.append("_method", "PUT");

      _pagination.updateData(graduate.id, "id", { is_enabled: checked });
    } catch (error) {
      console.log("🚀 ~ file: GraduateListing.ts ~ const_changeActiveStatus= ~ error", error);
    }
  };

  const onGridAction = (action: DATA_GRID_ACTIONS, id: number) => {
    console.log("onGridAction -- ", id);
    switch (action) {
      case DATA_GRID_ACTIONS.UNSUBSCRIBE:
        const staff = _pagination.data.find((item: IGraduateListItem) => item.id === id);
        staff && subscriptionModalRef?.current?.show(id, staff);
        break;
      case DATA_GRID_ACTIONS.EDIT:
        navigate(`${ROUTES.GRADUATE_PROFILE_EDITOR}/${id}`);
        break;
      default:
        break;
    }
  };

  const processFilters = (filters: Record<string, number[]>) => {
    const paramMap = [
      { id_param: "preference_ids", param: "preferences" },
      { id_param: "grade_band_ids", param: "grade_bands" },
    ];

    // delete filters.preference_ids;
    // delete filters.grade_band_ids;

    return paramMap.reduce((final, filter) => {
      if (filters[filter.id_param]) {
        const ids = filters[filter.id_param];
        ids.forEach(() => {});
        final[`filter[${filter.param}][has][id][in]`] = ids;
      }

      return final;
    }, {} as any);
  };

  const onFilterChange = (filters: Record<string, number[]>) => {
    const queryFilters = processFilters(filters);
    _pagination.onFilterChange({
      ...filters,
      ...queryFilters,
    });
  };

  return {
    ..._pagination,
    grades,
    roles,
    classYears,
    preferences,
    onFilterChange,
    onNewGraduateClick,
    onToggleActive,
    onGridAction,
    subscriptionModalRef,
  };
};

export default useGraduateListing;
